/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User info (update)
 */
import { ValidateUtils } from 'app/shared/utils';

export class UserInfoUpdate { 
    /**
     * Flag indicating whether User is beta tester
     */
    isBetaTester?: boolean;
    /**
     * Organization identifier to assign user to
     */
    organizationIdentifier?: string | null;
    /**
     * Optional notes about the organization request resolution
     */
    resolutionNotes?: string | null;

    constructor(item?: Partial<UserInfoUpdate>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            isBetaTester: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.isBetaTester : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            organizationIdentifier: {
                type: 'uuid',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.organizationIdentifier : itemOrValue;

                    if (itemOrValue?.organizationIdentifier != null) {
                        if (itemOrValue.organizationIdentifier === '') {
                            itemOrValue.organizationIdentifier = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.organizationIdentifier = parseInt(itemOrValue.organizationIdentifier.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.organizationIdentifier = parseFloat(itemOrValue.organizationIdentifier.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            resolutionNotes: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resolutionNotes : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: UserInfoUpdate.isValid,
        };
    }

    static isValid(obj: UserInfoUpdate): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = UserInfoUpdate.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.isBetaTester.isValid(item);
            result = result && validationObject.organizationIdentifier.isValid(item);
            result = result && validationObject.resolutionNotes.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

